module.exports = __webpack_public_path__ + "img/skill-2.9fdf481d.svg";